import React from 'react';

import { usePdpContext } from '../../pdp-provider';

import styles from './styles.cssm';

const Description = () => {
  const description = usePdpContext().product?.description;

  return description ? (
    <p
      className={`${styles.respectTextLineBreaks} color-textWhiteSoft text-xxs`}
      data-e2e="productDescription"
    >
      {description}
    </p>
  ) : null;
};

export default Description;
